import React from 'react';

const RecruitmentTable = () => {
  const tableData = [
  {
    "Sl No": 1,
    "Post Name": "Assistant Registrar",
    "Department": "-",
    "Level-I Question Paper": "Not Applicable",
    "File Link": "-"
  },
  {
    "Sl No": 2,
    "Post Name": "Technical Officer",
    "Department": "-",
    "Level-I Question Paper": "Technical Officer",
    "File Link": "Technical_Officer.pdf"
  },
  {
    "Sl No": 3,
    "Post Name": "Security Officer",
    "Department": "-",
    "Level-I Question Paper": "Security Officer",
    "File Link": "Security_Officer.pdf"
  },
  {
    "Sl No": 4,
    "Post Name": "Section Officer",
    "Department": "-",
    "Level-I Question Paper": "Section Officer",
    "File Link": "Section_Officer.pdf"
  },
  {
    "Sl No": 5,
    "Post Name": "Junior Superintendent",
    "Department": "-",
    "Level-I Question Paper": "Junior Superintendent",
    "File Link": "Junior_Superintendent.pdf"
  },
  {
    "Sl No": 6,
    "Post Name": "Junior Engineer- Civil",
    "Department": "-",
    "Level-I Question Paper": "Junior Engineer- Civil",
    "File Link": "Junior_Engineer-Civil.pdf"
  },
  {
    "Sl No": 7,
    "Post Name": "Junior Sports Officer",
    "Department": "-",
    "Level-I Question Paper": "Junior Sports Officer",
    "File Link": "Junior_Sports_Officer.pdf"
  },
  {
    "Sl No": 8,
    "Post Name": "Junior Technical Superintendent",
    "Department": "Chemical Engineering",
    "Level-I Question Paper": "JTS - CE",
    "File Link": "JTS_-_Chemical_Engineering.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technical Superintendent",
    "Department": "Computer Science & Engineering",
    "Level-I Question Paper": "JTS - Software & Systems Development",
    "File Link": "JTS_CSE_SSD_Level_I_A.pdf\nJTS_CSE_SSD_Level_I_B.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technical Superintendent",
    "Department": "Computer Science & Engineering",
    "Level-I Question Paper": "JTS - System Administration & Networking",
    "File Link": "JTS_CSE_SAN_Level_I_A.pdf\nJTS_CSE_SAN_Level-I_B.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technical Superintendent",
    "Department": "Dept. of HSS (1 post) & MAS (1 post)",
    "Level-I Question Paper": "JTS - Systems",
    "File Link": "-"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technical Superintendent",
    "Department": "Computer Centre",
    "Level-I Question Paper": "JTS - Systems",
    "File Link": "JTS_Systems_Computer_Centre.pdf"
  },
  {
    "Sl No": 9,
    "Post Name": "Junior Assistant",
    "Department": "-",
    "Level-I Question Paper": "Junior Assistant",
    "File Link": "Junior_Assistant.pdf"
  },
  {
    "Sl No": 10,
    "Post Name": "Junior Technician",
    "Department": "Chemical Engineering",
    "Level-I Question Paper": "JT - Chemical Engineering",
    "File Link": "-"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Civil & Environmental Engineering",
    "Level-I Question Paper": "JT - Civil & Environmental Engineering",
    "File Link": "JT-Civil_&_Environmental_Engineering.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Computer Science & Engineering",
    "Level-I Question Paper": "JT - Computer Science & Engineering",
    "File Link": "JT_CSE_Level_I_A.pdf\nJT_CSE_Level_I_B.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Electrical Engineering",
    "Level-I Question Paper": "JT - Electrical Engineering",
    "File Link": "JT_Electrical_Engineering.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Mechanical Engineering",
    "Level-I Question Paper": "JT - Mechanical Engineering",
    "File Link": "-"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Physics",
    "Level-I Question Paper": "JT - Physics",
    "File Link": "JT_Physics.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Central Instrumentation Facility",
    "Level-I Question Paper": "JT - Central Instrumentation Facility",
    "File Link": "JT_Central_Instrumentation_Facility.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Engineering Unit (Civil)",
    "Level-I Question Paper": "JT - Engineering Unit (Civil)",
    "File Link": "JT_Engineering_Unit(Civil).pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Centre of Excellence",
    "Level-I Question Paper": "JT - Centre of Excellence",
    "File Link": "JT_Centre_of_Excellence.pdf"
  },
  {
    "Sl No": "",
    "Post Name": "Junior Technician",
    "Department": "Computer Centre",
    "Level-I Question Paper": "JT - Computer Centre",
    "File Link": "JT_Computer_Centre.pdf"
  }
];

  const headers = Object.keys(tableData[0]);
  const rows = tableData;
  const BASE_URL = "https://files.iittp.ac.in/pdfs/recruitment/QP/2026/prevqpaper/";

  // Render cell with download link logic
  const renderCell = (cell, row, rowIndex, colIndex) => {
    if (colIndex === 3) {
      const fileLinks = row["File Link"].split('\n').map(f => f.trim()).filter(f => f && f !== '-');
      if (fileLinks.length > 0) {
        if (fileLinks.length === 1) {
          const downloadUrl = `${BASE_URL}${fileLinks[0]}`;
          return (
            <a 
              href={downloadUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{color: '#0066cc', textDecoration: 'none'}}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              {cell}
            </a>
          );
        } else {
          return (
            <div>
              {fileLinks.map((file, idx) => {
                const downloadUrl = `${BASE_URL}${file}`;
                return (
                  <div key={idx} style={{marginBottom: '5px'}}>
                    <a 
                      href={downloadUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{color: '#0066cc', textDecoration: 'none'}}
                      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                    >
                      {cell} Part {String.fromCharCode(65 + idx)}
                    </a>
                  </div>
                );
              })}
            </div>
          );
        }
      }
    }
    return cell;
  };

  return (
    <div className="recruitment-table">
      <h5>Advertisement No: IITT/STAFFREC/01/2025 dated: 14-07-2025</h5>
      <table style={{borderCollapse: 'collapse', marginBottom: '20px', width: '100%', fontFamily: 'Arial, sans-serif', fontSize: '14px'}}>
        <thead>
          <tr style={{backgroundColor: '#e8f4f8'}}>
            {headers.slice(0, 4).map((header, idx) => (
              <th key={idx} style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>
                {header || 'Dept/Notes'}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIdx) => (
            <tr key={rowIdx} style={{backgroundColor: rowIdx % 2 === 0 ? '#f9f9f9' : 'white'}}>
              {Object.values(row).slice(0, 4).map((cell, colIdx) => (
                <td key={colIdx} style={{border: '1px solid #ddd', padding: '12px', verticalAlign: 'top'}}>
                  {renderCell(cell, row, rowIdx, colIdx)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecruitmentTable;
